var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbbNutrition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Nutrition",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 40.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #febc11;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.77,11.77c.7-1.16,1.55-2.72,2.59-3.48,3.54-2.59,8.25-2.15,11.34,1.05,2.65,2.74,3.72,7.14,1.95,11.22-1.03,2.36-2.54,4.39-4.29,6.24-3.25,3.45-7,6.26-11.01,8.74-.4.25-.79.25-1.2,0-4.01-2.46-7.76-5.26-11.01-8.69-1.78-1.88-3.33-3.94-4.35-6.35-1.74-4.12-.56-8.75,2.36-11.49,1.91-1.8,4.19-2.63,6.8-2.36,2.83.3,4.98,2.39,6.56,4.74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbbNutrition);
export default __webpack_public_path__ + "static/media/ebb_nutrition.49edcf1cb29567c63172b6ab4dcfbfac.svg";
export { ForwardRef as ReactComponent };